<template>
  <v-app>
    <div class="beamer-club-assistant-page">
      <!-- Full Page Beamer Club Agent Modal -->
      <BeamerClubAgentModal
        v-model="showModal"
        @close="handleClose"
      />
    </div>
  </v-app>
</template>

<script>
import BeamerClubAgentModal from "@/components/BeamerClub/BeamerClubAgentModal.vue";

export default {
  name: "BeamerClubAssistant",
  components: {
    BeamerClubAgentModal
  },
  data() {
    return {
      showModal: true
    };
  },
  mounted() {
    console.log('🚗 Beamer Club Assistant page mounted');
    console.log('📋 showModal:', this.showModal);
    // Ensure modal is shown
    this.$nextTick(() => {
      this.showModal = true;
    });
  },
  methods: {
    handleClose() {
      console.log('🚪 Closing Beamer Club Assistant');
      // Redirect back to the previous page or home
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push('/');
      }
    }
  }
};
</script>

<style scoped>
.beamer-club-assistant-page {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

